import React, { useState } from 'react';
import './auth.css';
import { useAuth } from './AuthContext';

const VerifyEmail: React.FC<{ email: string }> = ({ email }) => {
  const { confirmEmail, resendCode, signOut } = useAuth();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setInfo('');
    try {
      await confirmEmail(code.trim());
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Verification failed');
    } finally {
      setLoading(false);
    }
  };

  const resend = async () => {
    setError('');
    setInfo('');
    try {
      await resendCode();
      setInfo('A new code is on the way.');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Resend failed');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h1>Check your email</h1>
        <p className="subtitle">
          We sent a 6-digit code to <strong>{email}</strong>. Enter it below.
        </p>
        <form onSubmit={submit}>
          <label htmlFor="code">Verification code</label>
          <input
            id="code" type="text" inputMode="numeric" pattern="\d*" required
            autoComplete="one-time-code" maxLength={6}
            value={code} onChange={(e) => setCode(e.target.value)}
          />
          <button className="primary" type="submit" disabled={loading || code.length < 6}>
            {loading ? 'Verifying…' : 'Verify'}
          </button>
        </form>
        {error && <div className="auth-message error">{error}</div>}
        {info && <div className="auth-message success">{info}</div>}
        <div className="auth-footer">
          Didn't get it?{' '}
          <button className="link" type="button" onClick={resend}>
            Resend code
          </button>
          {' · '}
          <button className="link" type="button" onClick={signOut}>
            Use a different email
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
